export default __webpack_public_path__ + "static/media/logo_af_pro.a135a323.svg";